"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _constants = require("@/utils/constants");

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Button: _button_widget.default
  },
  data: function data() {
    var validateMaxLength = function validateMaxLength(rule, value, callback) {
      if (value.trim() === '' || value === null) {
        callback(new Error(rule.colname + 'を入力してください。'));
      } else if (value.length > rule.maxLen) {
        callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
      } else {
        callback();
      }
    };

    return {
      waitDialogVisible: false,
      addDialogVisible: false,
      form: {
        roleName: ''
      },
      roleApp: [{
        'name': '個人チャット',
        'val': false,
        'id': 'app_private_chat_create'
      }, {
        'name': 'グループチャット',
        'val': false,
        'id': 'app_group_chat_create'
      }, {
        'name': 'チャットの画像を送信',
        'val': false,
        'id': 'app_allow_chat_image'
      }, {
        'name': 'チャットのファイルを送信',
        'val': false,
        'id': 'app_allow_chat_file'
      }, {
        'name': '組織チャットの編集',
        'val': false,
        'id': 'app_join_affiliation_chat_myself'
      }, {
        'name': 'アプリ内通話',
        'val': false,
        'id': 'app_make_call'
      }, {
        'name': '掲示板の閲覧',
        'val': false,
        'id': 'app_bulletin_board'
      }, {
        'name': '掲示板でのアンケート投票結果の閲覧',
        'val': false,
        'id': 'app_view_private_survey_result'
      }, {
        'name': '目安箱の作成',
        'val': false,
        'id': 'app_suggestion'
      }, {
        'name': '目安箱の画像を送信',
        'val': false,
        'id': 'app_allow_suggestion_image'
      }, {
        'name': '目安箱のファイルを送信',
        'val': false,
        'id': 'app_allow_suggestion_file'
      }, {
        'name': '既読者／未読者の閲覧',
        'val': false,
        'id': 'app_chat_read_view'
      }],
      roleAdmin: [{
        'name': 'ユーザーの登録',
        'val': false,
        'id': 'admin_user_add'
      }, {
        'name': 'ユーザー情報の編集',
        'val': false,
        'id': 'admin_user_edit'
      }, {
        'name': 'ユーザー情報の閲覧',
        'val': false,
        'id': 'admin_user_view'
      }, {
        'name': '掲示板の投稿',
        'val': false,
        'id': 'admin_bulletin_add'
      }, {
        'name': '掲示板のカテゴリーの編集',
        'val': false,
        'id': 'admin_bulletin_category_edit'
      }, {
        'name': '掲示板の編集',
        'val': false,
        'id': 'admin_bulletin_edit'
      }, {
        'name': '掲示板の閲覧',
        'val': false,
        'id': 'admin_bulletin_view'
      }, {
        'name': '目安箱の閲覧',
        'val': false,
        'id': 'admin_suggestion_view'
      }, {
        'name': '目安箱のカテゴリの編集',
        'val': false,
        'id': 'admin_suggestion_category_edit'
      }, {
        'name': '管理サイトのログイン',
        'val': false,
        'id': 'use_admin_site'
      }],
      validateMaxLength: function validateMaxLength(rule, value, callback) {
        if (value.trim() === '' || value === null) {
          callback(new Error(rule.colname + 'を入力してください。'));
        } else if (value.length > rule.maxLen) {
          callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
        } else {
          callback();
        }
      },
      rules: {
        roleName: [{
          required: true,
          validator: validateMaxLength,
          colname: '役割名',
          maxLen: 40
        }]
      }
    };
  },
  computed: {
    userRoles: function userRoles() {
      return this.$store.getters.userRoles;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    goToIndex: function goToIndex() {
      this.$router.replace({
        name: 'RoleIndex'
      });
    },
    handleDialogValidate: function handleDialogValidate() {
      var _this = this;

      this.$refs['form'].validate(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(valid) {
          var questionYesOrNo;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 7;
                    break;
                  }

                  _context2.next = 3;
                  return (0, _constants.message_box_confirm)('確認', '権限情報を登録します。よろしいですか？', '登録', 'message_default');

                case 3:
                  questionYesOrNo = _context2.sent;

                  if (questionYesOrNo) {
                    _this.handleOnAdd();
                  }

                  _context2.next = 9;
                  break;

                case 7:
                  _this.log('error submit!!');

                  return _context2.abrupt("return", false);

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleOnAdd: function () {
      var _handleOnAdd = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var roleApp, roleAdmin, findItemRoleApp, findItemRoleAdmin, dataRoles, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                findItemRoleAdmin = function _ref3(value) {
                  var roleItem = roleAdmin.filter(function (item) {
                    return item.id === value.toString().trim();
                  });

                  if (roleItem.length !== 0) {
                    return roleItem[0].val;
                  } else {
                    return false;
                  }
                };

                findItemRoleApp = function _ref2(value) {
                  var roleItem = roleApp.filter(function (item) {
                    return item.id === value.toString().trim();
                  });

                  if (roleItem.length !== 0) {
                    return roleItem[0].val;
                  } else {
                    return false;
                  }
                };

                this.addDialogVisible = false;
                this.waitDialogVisible = true;
                roleApp = this.roleApp;
                roleAdmin = this.roleAdmin;
                dataRoles = {
                  roles: {
                    name: this.form.roleName.toString().trim(),
                    app_private_chat_create: findItemRoleApp('app_private_chat_create'),
                    app_chat_read_view: findItemRoleApp('app_chat_read_view'),
                    app_make_call: findItemRoleApp('app_make_call'),
                    app_email: false,
                    app_map: false,
                    app_bulletin_board: findItemRoleApp('app_bulletin_board'),
                    app_allow_chat_image: findItemRoleApp('app_allow_chat_image'),
                    app_allow_chat_file: findItemRoleApp('app_allow_chat_file'),
                    app_allow_suggestion_image: findItemRoleApp('app_allow_suggestion_image'),
                    app_allow_suggestion_file: findItemRoleApp('app_allow_suggestion_file'),
                    app_custom_app_icon: false,
                    app_affiliation_direct_chat: true,
                    app_group_chat_create: findItemRoleApp('app_group_chat_create'),
                    app_view_private_survey_result: findItemRoleApp('app_view_private_survey_result'),
                    app_suggestion: findItemRoleApp('app_suggestion'),
                    app_join_affiliation_chat_myself: findItemRoleApp('app_join_affiliation_chat_myself'),
                    admin_bulletin_add: findItemRoleAdmin('admin_bulletin_add'),
                    admin_bulletin_category_edit: findItemRoleAdmin('admin_bulletin_category_edit'),
                    admin_bulletin_edit: findItemRoleAdmin('admin_bulletin_edit'),
                    admin_bulletin_view: findItemRoleAdmin('admin_bulletin_view'),
                    admin_user_add: findItemRoleAdmin('admin_user_add'),
                    admin_user_edit: findItemRoleAdmin('admin_user_edit'),
                    admin_user_view: findItemRoleAdmin('admin_user_view'),
                    admin_user_import: false,
                    use_admin_site: findItemRoleAdmin('use_admin_site'),
                    admin_suggestion_view: findItemRoleAdmin('admin_suggestion_view'),
                    admin_suggestion_category_edit: findItemRoleAdmin('admin_suggestion_category_edit')
                  }
                };
                _context3.next = 9;
                return this.$store.dispatch('company/insertRoles', dataRoles).catch(function (error) {
                  _this2.$notify({
                    title: 'エラー',
                    message: '役割の追加に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                  _this2.waitDialogVisible = false;
                  throw error;
                });

              case 9:
                result = _context3.sent;

                if (result) {
                  this.$notify({
                    title: '情報',
                    message: '役割の追加が完了しました。',
                    type: 'success',
                    duration: 2000
                  });
                  this.waitDialogVisible = false;
                  this.$router.replace({
                    name: 'RoleIndex'
                  });
                }

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleOnAdd() {
        return _handleOnAdd.apply(this, arguments);
      }

      return handleOnAdd;
    }()
  }
};
exports.default = _default;